export default __webpack_public_path__ + "static/media/intel-gold-1.c45263bc.png";